import { RefundPaymentCell } from './RefundPaymentCell';
import { ViewOnTilledCell } from './ViewOnTilledCell';
import type { InvoicePaymentRead } from 'src/common/external/bambi-api/bambiApi';

export function PaymentsActionCell({
  payment,
}: {
  payment: InvoicePaymentRead;
}) {
  const paymentFailed = payment.charge_status === 'failed';
  if (paymentFailed) {
    return null;
  }
  return (
    <div className="flex flex-row gap-2">
      <RefundPaymentCell payment={payment} />
      {payment.is_manual ? null : (
        <ViewOnTilledCell
          type="payments"
          resourceId={payment.external_payment_id!}
        />
      )}
    </div>
  );
}
